import { useEffect, useState } from "react";
import { NavLink } from 'react-router-dom';
import Modal from "./Modal";

import menuBurger from '../../images/menuBurger.png';
import logo from '../../images/LogoHeader.png';
import top from '../../images/top.png';
const Header = () => {
    const [projectMenuStateValue,setprojectMenuStateValue] = useState(true);
    const [isModalOpen, setModalOpen] = useState(false);
    const closeModal = () => setModalOpen(false);

    const changeMenuState = () => {
        setModalOpen(!isModalOpen);
    };

    useEffect(()=>{
        // console.log("состояние общего меню", headerStateValue);
        console.log('состояние менюшки проектов: ',projectMenuStateValue)
    })
    return(
        <>
            <Modal isOpen={isModalOpen} close={closeModal} />
            
            <section className="flex justify-between max-w-[1920px]  w-full
            sm:pl-10 pr-3
            md:px-12
            lg:px-[120px]
            xl:px-[120px]" id='homePage'>
                <div className="flex items-center py-2
                sm:flex-col sm:gap-2 text-xs
                md:flex-col md:gap-2
                lg:gap-10
                xl:gap-10 ">
                    <img src={logo} alt='logo header' className="max-w-[150px] max-h-14 sm:max-w-[120px]"/>
                    <p className=" font-extralight">Давайте делать БПЛА вместе!</p> 
                    {/* ДОБАВИТ КУРСИВ */}
                </div>
                
                <div className="sm:visible sm:flex sm:items-center md:invisible md:hidden lg:invisible lg:hidden xl:invisible xl:hidden" onClick={changeMenuState}>
                    <img src={menuBurger} alt="menu burger" className={isModalOpen === false ? 'w-8 h-8':'sm:invisible sm:hidden md:visible md:hidden'}/>
                </div>
                <div className="sm:invisible sm:hidden md:visible md:block">
                    <ul className="flex py-9
                    sm:gap-2
                    md:gap-8
                    lg:gap-10
                    xl:gap-12">
                        <NavLink to='/' className={({isActive})=>isActive ? 'text-[#304DB6] font-semibold':'cursor-pointer sm:text-sm'}>Главная</NavLink>
                        <li className="relative" onClick={()=>{setprojectMenuStateValue(!projectMenuStateValue)}}>
                            <div className="flex gap-2 items-center">
                                <p className="cursor-pointer sm:text-sm">Проекты</p>
                                <img src={top} alt="arrow top" className={projectMenuStateValue === true ? 'rotate-180 w-4 h-4' : 'w-4 h-4'} onClick={()=>{setprojectMenuStateValue(!projectMenuStateValue)}}/>
                                {/* <img src={bottom} alt="arrow bottom" className={arrowState === false ? 'invisible hidden' : 'w-4 h-4'} onClick={handleArrowState}/> */}
                            </div>
                            
                            <div className={projectMenuStateValue === true ? 'hidden invisible' : ' box-border absolute w-[110px] h-[50px] top-[30px] flex flex-col items-center justify-center gap-1 bg-[#FFFFFF] border-[#304DB6] border-2'}>
                                <NavLink to='/projectStrij' className={({isActive})=>isActive ? ' font-normal':'cursor-pointer font-medium sm:text-sm'}>ПК СТРИЖ</NavLink>
                            </div>
                        </li>
                        <NavLink to='/contacts' className={({isActive})=>isActive ? 'text-[#304DB6] font-semibold':'cursor-pointer sm:text-sm'}>Связаться</NavLink>
                    </ul>
                    
                </div>
            </section>
        </>
    )
} 
export default Header;